document.addEventListener('click', function(event){
  const toggle = event.target.closest('[data-hx-menu-toggle]');
  if(!toggle) return;
  const nav = document.querySelector('[data-hx-mobile-nav]');
  if(nav){ nav.toggleAttribute('hidden'); }
});

document.addEventListener('change', function(event){
  const variantSelect = event.target.closest('[data-variant-select]');
  if(!variantSelect) return;
  const form = variantSelect.closest('form');
  const priceNode = document.querySelector('[data-product-price]');
  const option = variantSelect.options[variantSelect.selectedIndex];
  if(priceNode && option && option.dataset.price){ priceNode.textContent = option.dataset.price; }
});

// HX product gallery fix: click thumbnails to show all uploaded Shopify product photos.
document.addEventListener('click', function(event){
  const thumb = event.target.closest('[data-hx-product-thumb]');
  if(!thumb) return;
  const gallery = thumb.closest('[data-hx-product-gallery]');
  if(!gallery) return;
  const mainImage = gallery.querySelector('[data-hx-product-main-image]');
  if(mainImage && thumb.dataset.full){
    mainImage.src = thumb.dataset.full;
    mainImage.removeAttribute('srcset');
    if(thumb.dataset.alt){ mainImage.alt = thumb.dataset.alt; }
  }
  gallery.querySelectorAll('[data-hx-product-thumb]').forEach(function(item){ item.classList.remove('is-active'); });
  thumb.classList.add('is-active');
});

// If a selected variant has its own featured image, update the main gallery image too.
document.addEventListener('change', function(event){
  const variantSelect = event.target.closest('[data-variant-select]');
  if(!variantSelect) return;
  const option = variantSelect.options[variantSelect.selectedIndex];
  if(!option || !option.dataset.featuredMedia) return;
  const gallery = document.querySelector('[data-hx-product-gallery]');
  const mainImage = gallery ? gallery.querySelector('[data-hx-product-main-image]') : null;
  if(mainImage){
    mainImage.src = option.dataset.featuredMedia;
    mainImage.removeAttribute('srcset');
    if(option.dataset.featuredMediaAlt){ mainImage.alt = option.dataset.featuredMediaAlt; }
  }
  if(gallery && option.dataset.featuredMediaId){
    gallery.querySelectorAll('[data-hx-product-thumb]').forEach(function(item){
      item.classList.toggle('is-active', item.dataset.full === option.dataset.featuredMedia);
    });
  }
});

// Cart UX: quantity changes update the cart automatically, and remove links stay available for errors.
let hxCartUpdateTimer;
document.addEventListener('change', function(event){
  const quantityInput = event.target.closest('[data-hx-cart-qty]');
  if(!quantityInput) return;
  const form = quantityInput.closest('form');
  if(!form) return;
  const value = parseInt(quantityInput.value, 10);
  if(Number.isNaN(value) || value < 0){
    quantityInput.value = Math.max(0, Number.isNaN(value) ? 0 : value);
  }
  clearTimeout(hxCartUpdateTimer);
  hxCartUpdateTimer = setTimeout(function(){
    const updateButton = form.querySelector('button[name="update"]');
    if(updateButton){ updateButton.click(); }
    else { form.submit(); }
  }, 600);
});
